import { render, staticRenderFns } from "./Psychological_archives.vue?vue&type=template&id=34a63434"
import script from "./Psychological_archives.vue?vue&type=script&lang=js"
export * from "./Psychological_archives.vue?vue&type=script&lang=js"
import style0 from "./Psychological_archives.vue?vue&type=style&index=0&id=34a63434&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports